import { queryOptions } from "@tanstack/react-query";
import { backendService } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_coreValuesSelected = () =>
	queryOptions({
		queryKey: ["core-values", "selected"] as const,
		queryFn: (context) =>
			extractionWrapper(
				backendService.corevalues.selectedCoreValuesControllerGetAll({
					signal: context.signal,
				}),
			),
	});
